import {ListGroup} from "react-bootstrap";
import * as React from "react";
import {GuidelineModel} from "../../../../../models/domain/guidelineModel";
import {FaPlusCircle} from "react-icons/fa";

export const ArtworkTemplatesAndGuidelines = ({
                                                  model: {
                                                      breakOutEarly,
                                                      title,
                                                      hasArtworkInstructions,
                                                      href,
                                                      count,
                                                      templates,
                                                      moreToShow,
                                                      showAll
                                                  }
                                              }: {
        model: {
            breakOutEarly: boolean;
            title: string;
            hasArtworkInstructions: boolean;
            href: string;
            count: number;
            templates: GuidelineModel[];
            moreToShow: boolean;
            showAll: () => void;
        };
    }) => {
        if (breakOutEarly) return <></>;

        return (
            <>
                <ListGroup variant="flush" className="mt-0">
                    <ListGroup.Item className="bg-light border-top">
                        <strong>
                            {title}
                        </strong>
                    </ListGroup.Item>
                    {hasArtworkInstructions && (
                        <ListGroup.Item action href={href} className="text-info">
                            View Artwork Instructions
                        </ListGroup.Item>
                    )}
                    {templates.map(({filename, url}, index) => (
                        <ListGroup.Item action href={url} target="_blank" className="text-info dont-break-out" key={index}>
                            {filename}
                        </ListGroup.Item>
                    ))}
                    {moreToShow && (
                        <ListGroup.Item onClick={showAll} action className="text-info d-flex align-items-center">
                            <FaPlusCircle className="me-1" aria-hidden/>Show all {count} templates
                        </ListGroup.Item>
                    )}
                </ListGroup>
            </>
        );
    }
;